import { render, staticRenderFns } from "./NewTemplatePicker.vue?vue&type=template&id=593cba2b&"
import script from "./NewTemplatePicker.vue?vue&type=script&lang=ts&"
export * from "./NewTemplatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./NewTemplatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports